import React from 'react';
import classNames from 'classnames';
import { getString } from '@nackle/intl-tools';

/**
 * A label component that displays a required field indicator with localized text.
 * 
 * @param {Object} props - The component props
 * @param {string} [props.className] - Additional CSS class name to apply
 * @param {string} [props.size] - Size variant for the label, one of ['small'|'medium'|'large']
 * @returns {React.ReactElement} The rendered required label component
 */
const NackleRequiredLabel = ( { className, size } ) => {
    const labelClasses = classNames( {
        'nackle-required-label': true,
        [ size ]: size ? true : false,
        [ className ]: className ? true : false
    } );
   return (
    <div className={ labelClasses }>
        <span className="required">*</span>{ getString( 'origami.required.label' ) }
    </div>
   );
};

export { NackleRequiredLabel };